

import React, { createContext, useContext } from 'react';





















const DataContext = createContext({
  shootstaPlayerProps: {},
  isPreview: false,
  replaceVariables: {},
  allowCalendarLinks: true,
  onButtonClick: () => void 0
});


export function DataAdapterProvider({
  children,
  replaceVariables,
  isPreview = false,
  allowCalendarLinks = true,
  shootstaPlayerProps = {},
  onButtonClick
}) {
  return (
    <DataContext.Provider
      value={{
        shootstaPlayerProps,
        replaceVariables,
        isPreview,
        allowCalendarLinks,
        onButtonClick
      }}>

      {children}
    </DataContext.Provider>);

}

export function useDataContext() {
  return useContext(DataContext);
}